import {
    Component,
    Inject,
    OnInit,
    ChangeDetectionStrategy,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import {
    MAT_DIALOG_DATA,
    MatDialogActions,
    MatDialogContent,
    MatDialogRef,
    MatDialogTitle,
} from '@angular/material/dialog';
import { tap } from 'rxjs';
import {
    AVS_CODE_LABELS,
    CVV_CODE_LABELS,
} from '../../../../../../../../core/enums/commerce/payment/authorize-net-codes';
import { AuthorizeNetPaymentTransactionDetailsResponse } from '../../../../../../../../core/models/commerce/payment/authorize-net-payment-transaction-details-response';
import { DraggableModalWrapperComponent } from '../../../../../../../../shared/components/modal/draggable-modal-wrapper/draggable-modal-wrapper.component';
import { PaymentService } from '../../../../../shared/services/payment/payment.service';
import { PaymentTransactionDetailsDialogModalData } from './models/payment-transaction-details-dialog-modal-data';

@Component({
    selector: 'app-payment-transaction-details-dialog',
    templateUrl: `./payment-transaction-details-dialog.component.html`,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        MatButtonModule,
        MatDialogContent,
        MatDialogActions,
        MatDialogTitle,
        DraggableModalWrapperComponent,
    ],
})
export class PaymentTransactionDetailsDialogComponent implements OnInit {
    response: AuthorizeNetPaymentTransactionDetailsResponse =
        {} as AuthorizeNetPaymentTransactionDetailsResponse;

    constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: PaymentTransactionDetailsDialogModalData,
        private readonly paymentService: PaymentService,
        private readonly dialogRef: MatDialogRef<PaymentTransactionDetailsDialogComponent>,
    ) {}

    get avsResponseLabel(): string {
        return this.response.avsResponse
            ? `${this.response.avsResponse} - ${AVS_CODE_LABELS[this.response.avsResponse]}`
            : 'N/A';
    }

    get cvvResponseLabel(): string {
        return this.response.cvvResponse
            ? `${this.response.cvvResponse} - ${CVV_CODE_LABELS[this.response.cvvResponse]}`
            : 'N/A';
    }

    ngOnInit(): void {
        this.paymentService
            .getDetails(this.data.orderId, this.data.paymentId)
            .pipe(
                tap((response) => {
                    this.response = response;
                }),
            )
            .subscribe();
    }

    close(): void {
        this.dialogRef.close(false);
    }
}
